var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFikautomation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 829.6 370.2",
    style: {
      enableBackground: "new 0 0 829.6 370.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#2B9BC6;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M411.8,236.2h-70.4c-7.3,0-13.2-5.7-13.2-12.7V0h71.2c6.9,0,12.4,5.3,12.4,11.9L411.8,236.2L411.8,236.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M715.1,106.3c-4.8,4.6-4.8,12,0,16.7l114.5,110.9v2.3H723.8c-3.2,0-6.3-1.2-8.7-3.4l-76.1-79.5 c-2.3-2.2-5.4-3.4-8.7-3.4h-58.2c-6.8,0-12.4,5.3-12.4,11.9v62.5c0,6.6-5.5,11.9-12.4,11.9h-54.4c-6.8,0-12.4-5.3-12.4-11.9V11.9 c0-6.6,5.5-11.9,12.4-11.9h54.4c6.8,0,12.4,5.3,12.4,11.9v60.9c0,6.6,5.5,11.9,12.4,11.9h57.6c3.2,0,6.3-1.2,8.6-3.3l99.1-78 c2.3-2.1,5.4-3.3,8.6-3.3h76.5v2.3L715.1,106.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M259.3,0v62.7H87.1c-6.8,0-10.2,3.5-10.2,10.5L77.1,85h182.3v61.9H90.2c-7.3,0-13.2,5.6-13.3,12.6l-1,76.7H0 V43.3C0,14.4,14.8,0,44.5,0L259.3,0L259.3,0z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "211.9,367.3 209,367.3 209,282.9 258.8,282.9 258.8,285.8 211.9,285.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "217.6,367.3 214.7,367.3 214.7,288.4 258.8,288.4 258.8,291.3 217.6,291.3  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "223.9,367.3 221,367.3 221,294.2 258.8,294.2 258.8,297.1 223.9,297.1  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "229.8,367.3 226.9,367.3 226.9,299.4 258.8,299.4 258.8,302.3 229.8,302.3  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 177.3,
    y: 282.9,
    className: "st0",
    width: 30.2,
    height: 2.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 177.3,
    y: 288.4,
    className: "st0",
    width: 30.2,
    height: 2.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 177.2,
    y: 293.9,
    className: "st0",
    width: 30.2,
    height: 2.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 177.3,
    y: 299.4,
    className: "st0",
    width: 30.2,
    height: 2.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 173.3,
    y: 282.4,
    className: "st0",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M178.2,287.2h-5.7v-5.7h5.7V287.2z M174.2,285.5h2.2v-2.2h-2.2V285.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 173.3,
    y: 287.9,
    className: "st0",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M178.2,292.8h-5.7V287h5.7V292.8z M174.2,291h2.2v-2.2h-2.2V291z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 173.3,
    y: 298.8,
    className: "st0",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M178.2,303.7h-5.7v-5.7h5.7V303.7z M174.2,301.9h2.2v-2.2h-2.2V301.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 173.3,
    y: 293.2,
    className: "st0",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M178.2,298h-5.7v-5.7h5.7V298z M174.2,296.3h2.2v-2.2h-2.2V296.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 257.8,
    y: 282.4,
    className: "st0",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M262.7,287.2H257v-5.7h5.7V287.2z M258.7,285.5h2.2v-2.2h-2.2V285.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 257.8,
    y: 287.9,
    className: "st0",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M262.7,292.8H257V287h5.7V292.8z M258.7,291h2.2v-2.2h-2.2V291z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 257.7,
    y: 293.3,
    className: "st0",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M262.6,298.2h-5.7v-5.7h5.7V298.2z M258.6,296.5h2.2v-2.2h-2.2V296.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 257.8,
    y: 298.8,
    className: "st0",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M262.7,303.7H257v-5.7h5.7V303.7z M258.7,301.9h2.2v-2.2h-2.2V301.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 226.3,
    y: 365.4,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 595.6804 139.0234)",
    className: "st0",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M231.2,370.2h-5.7v-5.7h5.7V370.2z M227.2,368.5h2.2v-2.2h-2.2V368.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 220.4,
    y: 365.4,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 589.791 144.9128)",
    className: "st0",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M225.3,370.2h-5.7v-5.7h5.7V370.2z M221.3,368.5h2.3v-2.2h-2.3V368.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 214.4,
    y: 365.3,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 583.7329 150.8786)",
    className: "st0",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M219.3,370.2h-5.7v-5.7h5.7V370.2z M215.3,368.4h2.2v-2.2h-2.2V368.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 208.4,
    y: 365.3,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 577.7208 156.8907)",
    className: "st0",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M213.3,370.2h-5.7v-5.7h5.7V370.2z M209.3,368.4h2.3v-2.2h-2.3V368.4z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28.9,346.3l-6.2,22.2H2.6L28.9,282h25.7l26.9,86.5H60.3l-6.7-22.2H28.9z M50.8,331.7l-5.4-18.3 c-1.5-5.1-3.1-11.5-4.4-16.7h-0.3c-1.3,5.1-2.6,11.7-4,16.7l-5.1,18.3H50.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M107.9,282v49.6c0,15,5.8,22.6,15.7,22.6c10.3,0,15.9-7.2,15.9-22.6V282h19.5v48.5c0,26.7-13.5,39.4-36,39.4 c-21.8,0-34.5-12.2-34.5-39.6V282H107.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M349.1,323.1c0,28.5-17.1,45.5-42.5,45.5c-25.5,0-40.7-19.4-40.7-44.1c0-25.9,16.7-45.3,42.1-45.3 C334.6,279.3,349.1,299.1,349.1,323.1z M286.6,324.2c0,17.1,8,29,21,29c13.2,0,20.8-12.6,20.8-29.4c0-15.6-7.3-29-20.8-29 C294.3,294.8,286.6,307.4,286.6,324.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M435.1,334.2c-0.4-10.4-0.8-23-0.8-35.5H434c-2.8,11-6.4,23.3-9.7,33.5l-10.5,33.7h-15.3l-9.2-33.4 c-2.8-10.3-5.6-22.6-7.8-33.9h-0.3c-0.4,11.7-0.9,25-1.4,35.8l-1.7,32.8H360l5.5-86.5h26l8.5,28.9c2.8,10,5.4,20.8,7.3,30.9h0.5 c2.3-10,5.3-21.4,8.2-31l9.1-28.7h25.7l4.6,86.5h-19L435.1,334.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M490.2,345.1l-6.2,22.2h-20.1l26.3-86.5h25.7l26.9,86.5h-21.2l-6.7-22.2H490.2z M512.2,330.4l-5.4-18.3 c-1.5-5.1-3.1-11.5-4.4-16.7h-0.3c-1.3,5.1-2.6,11.7-4,16.7l-5.1,18.3H512.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M560.4,297.2h-23.3v-16.4h66.4v16.4h-23.6v70h-19.5V297.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M633.6,280.8v86.5h-19.5v-86.5H633.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M729.6,323.1c0,28.5-17.1,45.5-42.5,45.5c-25.5,0-40.7-19.4-40.7-44.1c0-25.9,16.7-45.3,42.1-45.3 C715.1,279.3,729.6,299.1,729.6,323.1z M667.2,324.2c0,17.1,8,29,21,29c13.2,0,20.8-12.6,20.8-29.4c0-15.6-7.3-29-20.8-29 C674.9,294.8,667.2,307.4,667.2,324.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M742.5,367.3v-86.5h22.8l18,31.7c5.1,9.1,10.1,19.9,14.1,29.6h0.3c-1.2-11.4-1.5-23.1-1.5-36.2v-25.1h18 v86.5h-20.5l-18.5-33.4c-5.1-9.2-10.9-20.4-15-30.5h-0.5c0.6,11.5,0.9,23.7,0.9,37.8v26H742.5z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFikautomation);
export default __webpack_public_path__ + "static/media/FIKAUTOMATION.fb844a56829d21f61d63f1c16ef6d1cf.svg";
export { ForwardRef as ReactComponent };